import { cx } from '@chakra-ui/utils';
import { useContext } from 'react';
import type {
  SingleValueProps as ReactSingleValueProps,
  OptionTypeBase,
} from 'react-select';

import { Box, type BoxProps } from '@frontend/legacy-components';

import { SelectContext } from '../SelectContext';
import { useSelectStyles } from '../SelectStylesContext';
import { BASE_CLASS_NAME, SUGGESTION_FIELD_ICON_RESERVE_RIGHT } from '../const';

export type SingleValueProps<OptionType extends OptionTypeBase> =
  ReactSingleValueProps<OptionType> & {
    innerProps: BoxProps;
  };

export const SingleValue = <OptionType extends OptionTypeBase>({
  children,
  innerProps,
}: SingleValueProps<OptionType>) => {
  const { singleValue: singleValueStyles } = useSelectStyles();

  const { hasAcceptedSuggestions, hasSuggestions } = useContext(SelectContext);

  return (
    <Box
      {...innerProps}
      className={cx(`${BASE_CLASS_NAME}__single-value`, innerProps?.className)}
      __css={{
        ...singleValueStyles,
        ...(hasAcceptedSuggestions
          ? { color: 'interaction.suggestion' }
          : null),
        ...(hasSuggestions
          ? {
              left: 1,
              right: SUGGESTION_FIELD_ICON_RESERVE_RIGHT,
              maxWidth: 'none',
              mx: 0,
              px: 0.5,
            }
          : null),
      }}
    >
      {children}
    </Box>
  );
};
